import { useQuery } from '@tanstack/react-query'
import { useApi } from '@renderer/chat'

interface AudioNoteMetadataResponse {
  data?: { title?: string }
}

/** Search results don't carry a note's title, so each result row loads it from the note itself. */
export function useAudioNoteTitle(audioNoteId: string): string | undefined {
  const { get } = useApi()
  const { data } = useQuery({
    queryKey: ['audio-note-title', audioNoteId],
    queryFn: async () => {
      const response = await get(`audio-notes/${encodeURIComponent(audioNoteId)}?view=metadata`, { version: 'v1' })
      if (!response.ok) {
        throw new Error(`Failed to load the audio note's title: HTTP ${response.status}`)
      }
      const json = (await response.json()) as AudioNoteMetadataResponse
      return json.data?.title ?? null
    },
    staleTime: 5 * 60 * 1000,
  })
  return data ?? undefined
}
